import { useCollection } from "./useCollection";

export const useEventsQuery = (url, params = {}) => {

    const {
        items: events,
        loading,
        refetch, 
        removeItem
    } = useCollection(url, params);

    return {
        events,
        loading,
        refresh: refetch, 
        removeEvent: removeItem
    };
};
